import React, { ReactElement, useEffect, useState } from 'react';
import {
  Breadcrumbs,
  HiddenPriorityTitle,
  homeBreadcrumb,
  Message,
} from 'slovlex-idsk-react-components';
import { Loader } from 'idsk-react-components';
import routes from '../../routing/routes';
import Layout from '../Layout';
import { useClient } from '../../context/ClientStatusContext';
import { getKontaktSekcie } from '../../client/kontaktyClient';
import Kontakty from '../../module/Kontakty';
import insertScripts from '../../function/insertScripts';

const KontaktPage = (): ReactElement => {
  const {
    data,
    status,
  } = useClient(
    () => getKontaktSekcie(),
  );
  const [displayError, setDisplayError] = useState(true);

  useEffect(() => {
    if (data) {
      insertScripts([
        `${process.env.REACT_APP_SUBPATH}js/linkHandler.js`,
      ]);
    }
  }, [data]);

  return (
    <>
      <Layout>
        <HiddenPriorityTitle>Kontakt</HiddenPriorityTitle>
        <Breadcrumbs
          routeList={[
            homeBreadcrumb(process.env.REACT_APP_STATICKY_OBSAH_URL as string),
            {
              to: routes.kontakt.to,
              heading: routes.kontakt.name,
            },
          ]}
        />
        <Loader loading={status.loading}>
          {(status.responseCode && status.responseCode > 399) ? (
            <>
              {displayError && (
                <Message
                  type="error"
                  onClear={() => setDisplayError(false)}
                  headingSize="m"
                >
                  Nepodarilo sa načítať kontakty.
                </Message>
              )}
            </>
          )
            : (
              <Kontakty
                data={data}
              />
            )}
        </Loader>
      </Layout>
    </>
  );
};

// @ts-ignore
export default KontaktPage;
